export const referencesContent = {
    intro: "Více než 23 let poskytujeme služby v oblasti logistiky, energetiky, IT infrastruktury, telekomunikací a projektového řízení významným společnostem a organizacím v České republice.",
    customers: [
        "Pražská energetika, a.s.",
        "PRE Distribuce, a.s.",
        "PREservis, a.s.",
        "TECE Česká republika",
        "GreenPedal SE",
        "Kenvelo a.s.",
        "Union Consulting s.r.o.",
        "Wampano s.r.o.",
        "MUT Tubes s.r.o.",
        "MUT Automotive s.r.o."
    ],
    segments: [
        {
            id: "energy",
            title: "Energetika",
            customers: [
                "Pražská energetika, a.s.",
                "PRE Distribuce, a.s.",
                "PREservis, a.s."
            ],
            services: [
                "logistické projekty",
                "technická podpora",
                "energetická infrastruktura",
                "koordinace dodavatelských řetězců",
                "technologické dodávky"
            ]
        },
        {
            id: "industry",
            title: "Průmysl a stavebnictví",
            customers: ["TECE Česká republika"],
            services: [
                "logistické operace",
                "skladování",
                "koordinace dodavatelů",
                "projektové dodávky"
            ]
        },
        {
            id: "electromobility",
            title: "Elektromobilita a moderní technologie",
            customers: ["GreenPedal SE"],
            services: [
                "nabíjecí infrastruktura",
                "projektové řízení",
                "logistická podpora",
                "technické dodávky"
            ]
        },
        {
            id: "advisory",
            title: "Obchodní a poradenské služby",
            customers: ["Union Consulting s.r.o."],
            services: [
                "projektová koordinace NIS2",
                "logistické a obchodní poradenství",
                "řízení dodavatelských procesů"
            ]
        },
        {
            id: "retail",
            title: "Retail a obchodní řetězce",
            customers: ["Kenvelo a.s."],
            services: ["TELEKOMUNIKACE"]
        },
        {
            id: "wampano",
            title: "Wampano s.r.o.",
            customers: ["Wampano s.r.o."],
            services: [
                "projektové řízení",
                "logistika doprava",
                "technické dodávky",
                "logistika",
                "koordinace dodávek"
            ]
        }
    ]
};
